module.exports = __webpack_public_path__ + "static/img/qipingchazhaoxinxi.c2d44285.png";